import React from 'react';
import './GitRepositoryHeader.scss';

function GitRepositoryHeader() {
  return (<>
    <header className="git-repository-header">Git repository 👉🏻<a href="https://github.com/lorenzoVwebDev/redux-birds.git">Redux Birds</a></header>
  </>)
}

export default GitRepositoryHeader;